/**
 * @generated SignedSource<<bcbec291912f32a4bab7d3369075c78f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ForgotPasswordPage_customPortal$data = {
  readonly contactEmail: string | null;
  readonly customColor: string | null;
  readonly faviconUrl: string | null;
  readonly footerImageUrl: string | null;
  readonly headerFontColor: string | null;
  readonly logoImageUrl: string | null;
  readonly pageTitle: string | null;
  readonly " $fragmentType": "ForgotPasswordPage_customPortal";
};
export type ForgotPasswordPage_customPortal$key = {
  readonly " $data"?: ForgotPasswordPage_customPortal$data;
  readonly " $fragmentSpreads": FragmentRefs<"ForgotPasswordPage_customPortal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ForgotPasswordPage_customPortal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "footerImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headerFontColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "faviconUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactEmail",
      "storageKey": null
    }
  ],
  "type": "CustomPortalNode",
  "abstractKey": null
};

(node as any).hash = "1a820c07ec2cfc7ddfb48566a38e1a8e";

export default node;
